/**
 * @param  {event} evt evento del input
 * @param  {number} n numero de caracteres permitidos
 */
export default (evt, n) => {
    
    evt.target.value = evt.target.value.substring(0, n-1)
    if (evt.keyCode !== 8 && evt.keyCode !==9) {
        if (!(evt.keyCode >= 48 && evt.keyCode <= 57) && !(evt.keyCode >= 96 && evt.keyCode <= 105)) {
            evt.preventDefault()
            return
        }
        if (evt.target.value.length >= n-1 ) {  
        evt.preventDefault()
        return
        }
    }
  }
  